console.log("[TradeIn] Trade-in cart script loaded");

// Initialize Supabase client
window.initSupabase()
  .then(supabaseClient => {
    console.log("[TradeIn] Supabase initialized successfully");
    initTradeInCart(supabaseClient);
  })
  .catch(error => {
    console.error("[TradeIn] Failed to initialize Supabase:", error);
  });

function initTradeInCart(supabaseClient) {
  let tradeinState = {
    device_type: null,
    brand: null,
    model: null,
    storage: null,
    condition: null,
    price: null,
    product_id: null,
    currentStep: 1
  };

  // Map UI device types → Supabase types
  const DEVICE_TYPE_MAP = {
    smartphone: "Phone",
    phone: "Phone",
    laptop: "Laptop",
    tablet: "Tablet",
    smartwatch: "Smartwatch",
    watch: "Smartwatch"
  };

  function mapDeviceType(uiType) {
    if (!uiType) return null;
    const key = uiType.toString().toLowerCase().trim();
    return DEVICE_TYPE_MAP[key] || null;
  }

  async function fetchBrands(type) {
    try {
      const mappedType = mapDeviceType(type);

      let query = supabaseClient
        .from("bbti_products")
        .select("brand")
        .neq("brand", null);

      if (mappedType) query = query.eq("type", mappedType);

      const { data, error } = await query;
      if (error) throw error;

      return [...new Set(data.map(d => d.brand))];
    } catch (err) {
      console.error("[TradeIn] Error in fetchBrands:", err);
      return [];
    }
  }

  async function fetchModels(brand, type) {
    try {
      const mappedType = mapDeviceType(type);

      let query = supabaseClient
        .from("bbti_products")
        .select("model")
        .eq("brand", brand);

      if (mappedType) query = query.eq("type", mappedType);

      const { data, error } = await query;
      if (error) throw error;

      return [...new Set(data.map(d => d.model))];
    } catch (err) {
      console.error("[TradeIn] Error in fetchModels:", err);
      return [];
    }
  }

  async function fetchStorage(brand, model, type) {
    try {
      const mappedType = mapDeviceType(type);

      let query = supabaseClient
        .from("bbti_products")
        .select("id, storage")
        .eq("brand", brand)
        .eq("model", model);

      if (mappedType) query = query.eq("type", mappedType);

      const { data, error } = await query;
      if (error) throw error;

      return data;
    } catch (err) {
      console.error("[TradeIn] Error in fetchStorage:", err);
      return [];
    }
  }

  async function fetchPricing(productId) {
    try {
      const { data, error } = await supabaseClient
        .from("bbti_product_prices")
        .select("condition, price")
        .eq("product_id", productId);

      if (error) throw error;
      return data;
    } catch (err) {
      console.error("[TradeIn] Error in fetchPricing:", err);
      return [];
    }
  }

  function capitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // Update banner button when trade-in added
  function updateTradeInButtonState(brand, model, storage) {
    const tradeinButton = document.getElementById("launch-tradein-wizard");
    if (!tradeinButton) return;

    const buttonContent = tradeinButton.querySelector(".tradein-banner__content");
    if (buttonContent) {
      buttonContent.innerHTML = `
        <h4 class="tradein-banner__title">Trade-in added!</h4>
        <p class="tradein-banner__subtitle">You're trading in an ${brand} ${model} ${storage}GB</p>
      `;
    }

    tradeinButton.classList.add("tradein-banner__button--confirmed");
  }

  // Submit trade-in → adds ghost product to Shopify cart
  function handleTradeinFormSubmit() {
    const ghostProductId = window.TRADEIN_GHOST_PRODUCT_VARIANT_ID;

    const cleanDescription = `${tradeinState.brand} ${tradeinState.model} ${tradeinState.storage}GB / Condition: ${capitalize(tradeinState.condition)} / Value: £${tradeinState.price}`;

    const tradeinProps = {
      "Device": cleanDescription,

      _tradein_device_type: tradeinState.device_type,
      _tradein_brand: tradeinState.brand,
      _tradein_model: tradeinState.model,
      _tradein_storage: tradeinState.storage,
      _tradein_condition: tradeinState.condition,
      _tradein_price: tradeinState.price?.toString() || "",
      _tradein_product_id: tradeinState.product_id?.toString() || ""
    };

    updateTradeInButtonState(tradeinState.brand, tradeinState.model, tradeinState.storage);

    localStorage.setItem(
      "tradein_info",
      JSON.stringify({
        brand: tradeinState.brand,
        model: tradeinState.model,
        storage: tradeinState.storage,
        product_id: tradeinState.product_id
      })
    );

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: ghostProductId,
            quantity: 1,
            properties: tradeinProps
          }
        ],
        sections: window.theme.pageType == 'cart' ? 'main-cart' : ''
      })      
    })
      .then((r) => r.json())
      .then((data) => {
        console.log("[TradeIn] Added to cart:", data);

        if(data.sections && data.sections['main-cart']) {
          swapInSection(data.sections['main-cart'], 'main-cart', 'main-cart');          
        }

        document.getElementById("tradein").querySelector("[data-close-slideout]").click();

        // On PDP, change trade in trigger to message containing price
        document.querySelectorAll('.tradein-message').forEach((el) => {
          el.classList.toggle('tradein-hidden');
          if(el.querySelector('span')) {
            el.querySelector('span').innerText = '£' + tradeinProps._tradein_price;
          }
        });  
      })
      .catch((err) => {
        console.error("[TradeIn] Error adding to cart:", err);
        alert("There was an error adding your trade-in. Please try again.");
      });
  }

  async function checkCartForTradeIn() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      const tradeInItem = cart.items.find(
        (item) =>
          item.properties &&
          item.properties["Device"] &&
          item.id === window.TRADEIN_GHOST_PRODUCT_VARIANT_ID
      );

      if (tradeInItem) {
        const credit = tradeInItem.properties["Device"];

        updateTradeInButtonState("","", ""); // banner gets overridden by actual product anyway
      }
    } catch (err) {
      console.error("[TradeIn] Error checking cart:", err);
    }
  }

  function showStep(stepNumber) {
    const steps = document.querySelectorAll(".tradein-step");
    steps.forEach((s) => {
      const isMatch = parseInt(s.dataset.step) === stepNumber;
      s.style.display = isMatch ? "flex" : "none";
      s.classList.toggle("hidden", !isMatch);
    });

    tradeinState.currentStep = stepNumber;
  }

  async function handleNextStep(currentStep) {
    let isValid = false;
    let nextStep = currentStep + 1;

    switch (currentStep) {
      case 2: {
        const selectedCard = document.querySelector(".device-type-card.selected");
        if (selectedCard) {
          const device = selectedCard.dataset.device || selectedCard.innerText;
          tradeinState.device_type = device.trim();

          const brands = await fetchBrands(tradeinState.device_type);
          document.getElementById("tradein-brand").innerHTML =
            "<option value=''>Select brand</option>" +
            brands.map((b) => `<option value="${b}">${b}</option>`).join("");

          isValid = true;
        }
        break;
      }

      case 3: {
        const brand = document.getElementById("tradein-brand").value;
        if (brand) {
          tradeinState.brand = brand;

          const models = await fetchModels(brand, tradeinState.device_type);
          document.getElementById("tradein-model").innerHTML =
            "<option value=''>Select model</option>" +
            models.map((m) => `<option value="${m}">${m}</option>`).join("");

          isValid = true;
        }
        break;
      }

      case 4: {
        const model = document.getElementById("tradein-model").value;
        if (model) {
          tradeinState.model = model;

          const storageOptions = await fetchStorage(
            tradeinState.brand,
            model,
            tradeinState.device_type
          );

          document.getElementById("tradein-storage").innerHTML =
            "<option value=''>Select storage</option>" +
            storageOptions
              .map((o) => {
                const val = o.storage.replace(/GB/i, "").trim();
                return `<option value="${val}" data-id="${o.id}">${val}GB</option>`;
              })
              .join("");

          isValid = true;
        }
        break;
      }

      case 5: {
        const sel = document.getElementById("tradein-storage");
        const storage = sel.value;
        const productId = sel.selectedOptions[0]?.dataset.id;

        if (storage && productId) {
          tradeinState.storage = storage;
          tradeinState.product_id = productId;
          isValid = true;
        }
        break;
      }

      case 6: {
        const condition = document.querySelector('input[name="condition"]:checked')?.value;
        if (condition) {
          tradeinState.condition = condition;

          const pricing = await fetchPricing(tradeinState.product_id);
          const match = pricing.find(
            (p) => p.condition.toLowerCase().trim() === condition.toLowerCase().trim()
          );
          tradeinState.price = match?.price || 0;

          document.getElementById("tradein-offer-summary").innerHTML = `
            <h3>Your Trade-In Offer</h3>
            <div class="tradein-summary-details">
              <div class="tradein-summary-item">
                <span class="summary-label">Device:</span>
                <span class="summary-value">${tradeinState.brand} ${tradeinState.model}</span>
              </div>
              <div class="tradein-summary-item">
                <span class="summary-label">Storage:</span>
                <span class="summary-value">${tradeinState.storage}GB</span>
              </div>
              <div class="tradein-summary-item">
                <span class="summary-label">Condition:</span>
                <span class="summary-value">${capitalize(
                  tradeinState.condition
                )}</span>
              </div>
            </div>
            <div class="trade-in-price">£${tradeinState.price}</div>
          `;

          isValid = true;
        }
        break;
      }
    }

    if (isValid) showStep(nextStep);
  }

  function handleBackStep(step) {
    showStep(parseInt(step));
  }

  window.TradeinCart = {
    state: tradeinState,
    fetchBrands,
    fetchModels: (brand) => fetchModels(brand, tradeinState.device_type),
    fetchStorage: (brand, model) => fetchStorage(brand, model, tradeinState.device_type),
    fetchPricing,
    submit: handleTradeinFormSubmit
  };

  document.addEventListener("DOMContentLoaded", () => {
    // Device type card click
    document.querySelectorAll(".device-type-card").forEach((card) => {
      card.addEventListener("click", async function () {
        const type = this.dataset.device || this.innerText;
        tradeinState.device_type = type.trim();

        document
          .querySelectorAll(".device-type-card")
          .forEach((c) => c.classList.remove("selected"));
        this.classList.add("selected");

        // Move immediately to step 3
        await handleNextStep(2);
      });
    });

    // Navigation
    document.getElementById("to-step-2").addEventListener("click", () => showStep(2));
    document.getElementById("to-step-4").addEventListener("click", () => handleNextStep(3));
    document.getElementById("to-step-5").addEventListener("click", () => handleNextStep(4));
    document.getElementById("to-step-6").addEventListener("click", () => handleNextStep(5));
    document.getElementById("to-step-7").addEventListener("click", () => handleNextStep(6));
    document.getElementById("tradein-submit").addEventListener("click", handleTradeinFormSubmit);

    document.querySelectorAll(".tradein-back-button").forEach((btn) => {
      btn.addEventListener("click", () => handleBackStep(btn.dataset.step));
    });

    checkCartForTradeIn();
  });

  console.log("[TradeIn] Trade-in module ready");
}
